import { render, staticRenderFns } from "./UpdateMobileTel.vue?vue&type=template&id=5a689ea4"
import script from "./UpdateMobileTel.vue?vue&type=script&lang=js"
export * from "./UpdateMobileTel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports